import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "components/Frontend/Header";
import Footer from "components/Frontend/Footer";
import Slider from 'react-slick';


const StageSlider = {
  dots: true,
  arrows: true, 
  infinite: true,
  speed: 500,
  slidesToShow: 1, 
  slidesToScroll: 1,
  autoplay: true,
  adaptiveHeight: true,
  autoplaySpeed: 2000 
};



export default function SalesPage(props) {
  return (
    <React.Fragment>
      <Header />
      <div className="banner-section">
        <div className="container">
          <div className="row">
            <div className="banner-content">
              <div className="banner-inner-content">
                <h1 className="mfw-600 primary-heading dark-blue-color">
                  The Instant Score Booster No One Tells You About
                </h1>
              </div>
              <div className="iframe-video-outer position-relative">
                {/* <div className="iframe-video-wrapper">
                  <iframe
                    className="iframe-video"
                    src="https://www.youtube.com/embed/2HkGcclJhZ4?si=nR6zWS6G0J1LSYSl"
                    title="YouTube video player"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div> */}
                <div className="banner-img-wrapper">
                  <img
                    className="banner-img"
                    src="/images/web-new-images/banners/sale-banner.png"
                    alt="LA"
                  />
                </div>
                <img
                  className="emoji1 position-absolute"
                  src="/images/web-new-images/emojis/emoji-1.png"
                  alt="LA"
                />
                <img
                  className="emoji2 position-absolute"
                  src="/images/web-new-images/emojis/emoji-2.png"
                  alt="LA"
                />
                <img
                  className="emoji3 position-absolute"
                  src="/images/web-new-images/emojis/emoji-3.png"
                  alt="LA"
                />
                <img
                  className="emoji4 position-absolute"
                  src="/images/web-new-images/emojis/emoji-4.png"
                  alt="LA"
                />
              </div>
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  REGISTER NOW{" "}
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="sales-content">
        <div className="container">
          <div className="row">
            <p>
              You read, write, and speak English fluently—yet your score keeps
              falling short.
              <br />
              <br />
              It makes no sense…
              <br />
              <br />
              until you understand the truth.
              <br />
              <br />
              These tests aren’t just checking your grammar or vocabulary.
              They're machines—coded systems—with specific behaviors, templates,
              timing patterns, and algorithmic preferences that punish what they
              weren’t designed to reward.
              <br />
              <br />
              Every time you “practice harder” or “improve your English,”
              without decoding how these systems score, you're gambling your
              future on luck. That’s why students who ace academic essays,
              perform confidently in interviews, and use English daily still
              fail these exams again and again. It isn’t that they’re
              unprepared.
              <br />
              <br />
              It’s that no one ever showed them how these exams actually work.
              You see, passing PTE, NAATI CCL, or IELTS efficiently has nothing
              to do with being “good at English”… and everything to do with
              knowing what earns marks and what gets ignored—even penalized.
              <br />
              <br />
              You’ll stop wasting time on skills that don’t matter You’ll focus
              only on those that do You’ll finally start seeing results You’ll
              get clear feedback based on the real scoring models—not vague
              advice from outdated videos.
              <br />
              <br />
              And you’ll finally break free from the confusion, conflicting
              tips, and random YouTube strategies that haven’t worked so far.
              <br />
              <br />
              That’s how hundreds of international students and professionals go
              from repeated failures to securing their visas, jobs, or permanent
              residency fast—often in just weeks.
              <br />
              <br />
              All because they stopped trying to learn more English… and started
              learning the exam.
              <br />
              <br />
              Sound like what you’ve been missing? Let’s get into it.
            </p>
          </div>
        </div>
      </div>
      <div className="steps-section">
        <div className="container">
          <div className="row">
            <div className="step step1">
              <div className="step-left">
                <div className="left-step-title">
                  <p>
                    Step <span className="count">1</span>
                  </p>
                  <div className="left-step-icon">
                    <img
                      src="/images/web-new-images/sales-page-img/icon-01.png"
                      alt="Image"
                    />
                  </div>
                </div>
                <h2 className="left-step-heading">
                  Improving <br /> Your English
                </h2>
              </div>
              <div className="step-right">
                <h2>
                  You Don’t Need Perfect English—You Need the Right System
                </h2>
                <img
                  src="/images/web-new-images/sales-page-img/step-01.png"
                  alt="Image"
                />
                <p>
                  <br />
                  The cruelest irony?
                  <br />
                  <br />
                  Some of the most fluent speakers fail these exams.
                  <br />
                  Not once.
                  <br />
                  Not twice.
                  <br />
                  Sometimes over and over.
                  <br />
                  It’s not their grammar.
                  <br />
                  Or accent.
                  <br />
                  Or vocabulary.
                  <br />
                  It’s that they’re solving the wrong problem.
                  <br />
                  <br />
                  <br />
                  These tests aren’t designed to measure your English—they’re
                  built to measure how well you fit into a specific scoring
                  model.
                  <br />
                  <br />
                  <br />
                  And unless you’re trained to speak the “exam’s language,” your
                  real skill never even reaches the algorithm.
                  <br />
                  <br />
                  <br />
                  You’re chasing fluency when what you need is decoding.
                  <br />
                  Once you shift focus from “getting better at English” to
                  “working with the system,” you'll stop spinning your wheels
                  and finally move forward.
                </p>
              </div>
              <div className="step-center-img">
                <svg
                  width="61"
                  height="2070"
                  viewBox="0 0 61 2070"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1035L5 1037.89V1032.11L0 1035ZM4.5 1035V1035.5H58V1035V1034.5H4.5V1035Z"
                    fill="#7F56D9"
                  />
                  <path
                    d="M55.3333 3C55.3333 4.47276 56.5272 5.66667 58 5.66667C59.4728 5.66667 60.6667 4.47276 60.6667 3C60.6667 1.52724 59.4728 0.333333 58 0.333333C56.5272 0.333333 55.3333 1.52724 55.3333 3ZM55.3333 2067C55.3333 2068.47 56.5272 2069.67 58 2069.67C59.4728 2069.67 60.6667 2068.47 60.6667 2067C60.6667 2065.53 59.4728 2064.33 58 2064.33C56.5272 2064.33 55.3333 2065.53 55.3333 2067ZM58 3H57.5V2067H58H58.5V3H58Z"
                    fill="#7F56D9"
                  />
                </svg>
              </div>
            </div>
            <div className="step step2">
              <div className="step-left">
                <div className="left-step-title">
                  <p>
                    Step <span className="count">2</span>
                  </p>
                  <div className="left-step-icon">
                    <img
                      src="/images/web-new-images/sales-page-img/icon-02.png"
                      alt="Image"
                    />
                  </div>
                </div>
                <h2 className="left-step-heading">
                  Stop <br /> Collecting <br /> Free Materials
                </h2>
              </div>
              <div className="step-right">
                <h2>
                  Free Can Be the <br /> Most Expensive Path.
                </h2>
                <img
                  src="/images/web-new-images/sales-page-img/step-02.png"
                  alt="Image"
                />
                <p>
                  <br />
                  There’s no shortage of PDFs, practice files, or “updated
                  templates” online.
                  <br />
                  <br />
                  But what’s missing?
                  <br />
                  <br />
                  The scoring logic behind knowing when—and how—to use them
                  <br />
                  <br />
                  You don’t need more information.
                  <br />
                  You need transformation.
                  <br />
                  Templates don’t work unless they’re applied precisely.
                  <br />
                  <br />
                  Predictions help only if they align with the current scoring
                  cycle.
                  <br />
                  <br />
                  And feedback matters more than any file.
                  <br />
                  Free platforms rarely update.
                  <br />
                  They don’t reflect scoring changes.
                  <br />
                  And they leave you correcting the wrong things.
                  <br />
                  <br />
                  You spend weeks preparing in the wrong direction—only to fail
                  by 1 point again.
                  <br />
                  Stop gambling with guesswork.
                  <br />
                  <br />
                  Structured corrections and tailored strategies beat free
                  shortcuts every time.
                </p>
              </div>
              <div className="step-center-img">
                <svg
                  width="61"
                  height="2070"
                  viewBox="0 0 61 2070"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1035L5 1037.89V1032.11L0 1035ZM4.5 1035V1035.5H58V1035V1034.5H4.5V1035Z"
                    fill="#7F56D9"
                  />
                  <path
                    d="M55.3333 3C55.3333 4.47276 56.5272 5.66667 58 5.66667C59.4728 5.66667 60.6667 4.47276 60.6667 3C60.6667 1.52724 59.4728 0.333333 58 0.333333C56.5272 0.333333 55.3333 1.52724 55.3333 3ZM55.3333 2067C55.3333 2068.47 56.5272 2069.67 58 2069.67C59.4728 2069.67 60.6667 2068.47 60.6667 2067C60.6667 2065.53 59.4728 2064.33 58 2064.33C56.5272 2064.33 55.3333 2065.53 55.3333 2067ZM58 3H57.5V2067H58H58.5V3H58Z"
                    fill="#7F56D9"
                  />
                </svg>
              </div>
            </div>
            <div className="step step3">
              <div className="step-left">
                <div className="left-step-title">
                  <p>
                    Step <span className="count">3</span>
                  </p>
                  <div className="left-step-icon">
                    <img
                      src="/images/web-new-images/sales-page-img/icon-03.png"
                      alt="Image"
                    />
                  </div>
                </div>
                <h2 className="left-step-heading">
                  Quit Mixing <br /> Advice From <br /> Everywhere
                </h2>
              </div>
              <div className="step-right">
                <h2>Conflicting Tips Kill Clarity.</h2>
                <img
                  src="/images/web-new-images/sales-page-img/step-03.png"
                  alt="Image"
                />
                <p>
                  <br />
                  Everyone’s got an opinion—Reddit threads, YouTube videos, even
                  your friends who passed once.
                  <br />
                  <br />
                  So you stack all those strategies together, thinking more is
                  better.
                  <br />
                  <br />
                  But the result?
                  <br />
                  <br />
                  Chaos.
                  <br />
                  <br />
                  You follow Technique A for Speaking.
                  <br />
                  Mix it with Method B’s Retell Template.
                  <br />
                  Throw in C’s time-saving hack.
                  <br />
                  <br />
                  Now you're stuck in a Frankenstein strategy that confuses both
                  you and the scoring bots.
                  <br />
                  These exams reward consistency, not creativity. Drop the
                  mashups
                  <br />
                  <br />
                  Choose one proven system and follow it with precision.
                  <br />
                  You’ll cut your prep time in half—and finally see what
                  actually works.
                </p>
              </div>
              <div className="step-center-img">
                <svg
                  width="61"
                  height="2070"
                  viewBox="0 0 61 2070"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1035L5 1037.89V1032.11L0 1035ZM4.5 1035V1035.5H58V1035V1034.5H4.5V1035Z"
                    fill="#7F56D9"
                  />
                  <path
                    d="M55.3333 3C55.3333 4.47276 56.5272 5.66667 58 5.66667C59.4728 5.66667 60.6667 4.47276 60.6667 3C60.6667 1.52724 59.4728 0.333333 58 0.333333C56.5272 0.333333 55.3333 1.52724 55.3333 3ZM55.3333 2067C55.3333 2068.47 56.5272 2069.67 58 2069.67C59.4728 2069.67 60.6667 2068.47 60.6667 2067C60.6667 2065.53 59.4728 2064.33 58 2064.33C56.5272 2064.33 55.3333 2065.53 55.3333 2067ZM58 3H57.5V2067H58H58.5V3H58Z"
                    fill="#7F56D9"
                  />
                </svg>
              </div>
            </div>
            <div className="step step4">
              <div className="step-left">
                <div className="left-step-title">
                  <p>
                    Step <span className="count">4</span>
                  </p>
                  <div className="left-step-icon">
                    <img
                      src="/images/web-new-images/sales-page-img/icon-04.png"
                      alt="Image"
                    />
                  </div>
                </div>
                <h2 className="left-step-heading">
                  Stop Studying <br /> Alone
                </h2>
              </div>
              <div className="step-right">
                <h2>
                  Self-Study Isn’t <br /> Self-Sufficiency.
                </h2>
                <img
                  src="/images/web-new-images/sales-page-img/step-04.png"
                  alt="Image"
                />
                <p>
                  <br />
                  You’re smart.
                  <br />
                  You’re motivated.
                  <br />
                  You’ve aced harder things.
                  <br />
                  <br />
                  But this isn’t a knowledge test—it’s a performance test inside
                  a machine.
                  <br />
                  <br />
                  And like any system, it punishes the unaware.
                  <br />
                  Studying alone might feel productive—but it leaves your blind
                  spots untouched.
                  <br />
                  <br />
                  Without real-time correction, you'll keep practicing the same
                  mistake.
                  <br />
                  <br />
                  Without professional scoring, you’re trusting your gut over
                  the algorithm.
                  <br />
                  <br />
                  That’s why self-study often creates false confidence… and
                  bitter disappointment.
                  <br />
                  <br />
                  You’ll move faster—and score higher—when you stop guessing and
                  start getting feedback.
                </p>
              </div>
              <div className="step-center-img">
                <svg
                  width="61"
                  height="2070"
                  viewBox="0 0 61 2070"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1035L5 1037.89V1032.11L0 1035ZM4.5 1035V1035.5H58V1035V1034.5H4.5V1035Z"
                    fill="#7F56D9"
                  />
                  <path
                    d="M55.3333 3C55.3333 4.47276 56.5272 5.66667 58 5.66667C59.4728 5.66667 60.6667 4.47276 60.6667 3C60.6667 1.52724 59.4728 0.333333 58 0.333333C56.5272 0.333333 55.3333 1.52724 55.3333 3ZM55.3333 2067C55.3333 2068.47 56.5272 2069.67 58 2069.67C59.4728 2069.67 60.6667 2068.47 60.6667 2067C60.6667 2065.53 59.4728 2064.33 58 2064.33C56.5272 2064.33 55.3333 2065.53 55.3333 2067ZM58 3H57.5V2067H58H58.5V3H58Z"
                    fill="#7F56D9"
                  />
                </svg>
              </div>
            </div>
            <div className="step step5">
              <div className="step-left">
                <div className="left-step-title">
                  <p>
                    Step <span className="count">5</span>
                  </p>
                  <div className="left-step-icon">
                    <img
                      src="/images/web-new-images/sales-page-img/icon-05.png"
                      alt="Image"
                    />
                  </div>
                </div>
                <h2 className="left-step-heading">
                  Don’t Wait <br /> Until You “Feel <br /> Ready
                </h2>
              </div>
              <div className="step-right">
                <h2>
                  Mastery Isn’t a Feeling <br /> —It’s a System.
                </h2>
                <img
                  src="/images/web-new-images/sales-page-img/step-05.png"
                  alt="Image"
                />
                <p>
                  <br />
                  You keep telling yourself, “Just a few more days. A few more
                  practices. Then I’ll book it.”
                  <br />
                  <br />
                  But readiness doesn’t bloom from repetition alone.
                  <br />
                  Confidence comes from pattern recognition.
                  <br />
                  <br />
                  From knowing you’re following scoring logic—step by step.
                  <br />
                  <br />
                  The breakthrough isn’t grinding 10 hours a day.
                  <br />
                  It’s knowing exactly why your last answer scored low—and how
                  to fix it.
                  <br />
                  <br />
                  When your prep is strategic, you don’t have to “feel” ready.
                  <br />
                  <br />
                  You’ll be ready.
                  <br />
                  Stop delaying.
                  <br />
                  Start decoding.
                  <br />
                  <br />
                  And take back control over the exam.
                </p>
              </div>
              <div className="step-center-img">
                <svg
                  width="61"
                  height="2070"
                  viewBox="0 0 61 2070"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1035L5 1037.89V1032.11L0 1035ZM4.5 1035V1035.5H58V1035V1034.5H4.5V1035Z"
                    fill="#7F56D9"
                  />
                  <path
                    d="M55.3333 3C55.3333 4.47276 56.5272 5.66667 58 5.66667C59.4728 5.66667 60.6667 4.47276 60.6667 3C60.6667 1.52724 59.4728 0.333333 58 0.333333C56.5272 0.333333 55.3333 1.52724 55.3333 3ZM55.3333 2067C55.3333 2068.47 56.5272 2069.67 58 2069.67C59.4728 2069.67 60.6667 2068.47 60.6667 2067C60.6667 2065.53 59.4728 2064.33 58 2064.33C56.5272 2064.33 55.3333 2065.53 55.3333 2067ZM58 3H57.5V2067H58H58.5V3H58Z"
                    fill="#7F56D9"
                  />
                </svg>
              </div>
            </div>
            <div className="text-center">
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  REGISTER NOW{" "}
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="sales-content">
        <div className="container">
          <div className="row">
            <h2 className="title">
              There's A Smarter <br /> Way To Pass
            </h2>
            <p>
              <br />
              For over 7 years, we’ve helped thousands of students unlock the
              one thing most never consider about these exams: the system behind
              the score. That’s right—these aren't just English exams.
              <br />
              <br />
              They're technical evaluations with strict scoring rules. Specific
              response structures.
              <br />
              <br />
              Algorithmic blind spots—details fluent speakers often miss.
              <br />
              <br />
            </p>
            <h3 className="sub-title">
              Yet when you follow our <br /> approach, things change fast:
            </h3>
            <p>
              <br />
              You won’t need to cram more vocabulary.
              <br />
              You won’t need to watch endless “free tip” videos that contradict
              each other.
              <br />
              <br />
              And you definitely won’t need to second-guess every answer,
              praying it fits some invisible standard.
              <br />
              <br />
              You see, you don’t fail these exams because your English isn't
              good enough.
              <br />
              <br />
              You fail because you haven’t been trained to speak the exam’s
              language—its logic.
              <br />
              That’s where we come in.
              <br />
              <br />
              <br />
            </p>
            <div className="sales-gray-box">
              <h2 className="title">
                WARNING: This Is Not <br /> For Everyone!
              </h2>
              <br />
              <p>
                Let’s be clear about what this is NOT.
                <br />
                <br />
                If you love hopping between forums hoping the next YouTube guru
                cracks the code, keep clicking.
                <br />
                <br />
                If you’re convinced another hour of solo practice will magically
                turn things around, this won’t help you.
                <br />
                <br />
                And if you’re looking for a shortcut that avoids structure,
                system, or feedback—this isn’t for you either.
                <br />
                <br />
                But…
                <br />
                <br />
                If you’re done spinning your wheels.
                <br />
                If you want the truth about how these exams really work—and
                you're ready to approach it with focus, clarity, and guided
                support —you’re exactly where you need to be.
                <br />
                <br />
                Because once you stop guessing and start applying proven
                techniques inside a precision-tuned system, everything clicks.
                You’ll follow tested templates.
                <br />
                <br />
                You’ll get expert feedback on what matters. And you’ll start
                seeing scores that match your true potential —not random guesses
                from faulty online tools.
                <br />
                <br />
                So, what do I do next?
              </p>
            </div>
            <div className="attention-card">
              <h2>
                <img
                  src="/images/web-new-images/sales-page-img/info-icon.svg"
                  alt="Image"
                />{" "}
                ATTENTION
              </h2>
              <p>
                International students, working professionals, and ambitious
                migrants ready to move forward in life
              </p>
            </div>
            <img
              className="img-fluid sale-img"
              src="/images/web-new-images/sales-page-img/img-01.png"
              alt="Image"
            />
            <h2 className="title">
              <br />
              The Hidden System <br /> Behind Your Exam Result
            </h2>
            <h3 className="sub-title my-4">
              You Can Finally Stop Guessing, Stop Failing, and Start
              Passing—Once You Learn What the Exam Is Really Testing (And It's
              Not Just Your English)
            </h3>
            <p>
              <br />
              You’ve done the mock tests.
              <br />
              You’ve studied hard.
              <br />
              Friends say your English is great.
              <br />
              But the scores… keep falling short.
              <br />
              Again.
              <br />
              <br />
              That’s not because you need to “improve your English.”
              <br />
              It’s because you've been solving the wrong problem.
              <br />
              <br />
              These exams are not just about grammar or vocabulary—they’re built
              on algorithms, scoring mechanics, and a sequence of secret
              priorities that assess far more than language skill.
              <br />
              <br />
              Once you understand how the system actually works, everything
              changes.
              <br />
              You’ll know which tasks carry the most weight.
              <br />
              You’ll use templates that match the scoring engine.
              <br />
              <br />
              You’ll stop wasting time on things that don’t move your score.
              <br />
              And most importantly—you’ll pass.
              <br />
              <br />
              You’ve been told to just keep practicing harder.
              <br />
              You've downloaded free resources.
              <br />
              <br />
              Maybe you’ve even tried copying templates from forums.
              <br />
              But those tools won’t give you the critical feedback, current
              prediction files, or test-specific strategy that unlocks the real
              score boosters buried inside the exam structure.
              <br />
              <br />
              And that’s the reason why even fluent English speakers keep
              failing—while others with less fluency blow past them.
              <br />
              This page pulls back the curtain.
              <br />
              Inside, you’ll discover what really drives your score.
              <br />
              <br />
              You’ll meet someone who cracked the code, and you’ll see how
              others just like you turned failure into fast success.
              <br />
              <br />
              So keep reading—because everything you thought you knew about
              passing this exam is about to be rewritten.
            </p>
            <h3 className="sub-title">
              Forget cramming vocabulary lists or binge-watching tutorials —
              it’s not the answer
            </h3>
            <p>
              <br />
              You’ve spent weeks drilling grammar.
              <br />
              Downloaded every free resource.
              <br />
              <br />
              Tried to reverse-engineer success by patching together advice from
              YouTube, Reddit, and friends who “sort of” passed.
              <br />
              <br />
              And yet... you're still falling short.
              <br />
              <br />
              That’s not because your English isn't good enough — far from it.
              <br />
              It’s because these exams don’t reward “good English.”
              <br />
              <br />
              They reward knowing how the system scores.
              <br />
              You see, these tests aren’t just tests of language.
              <br />
              They’re technical games with rules.
              <br />
              Rules few students know exist.
              <br />
              <br />
              So each time you practice with a random template, follow a tip
              from a friend, or trust that more practice will “eventually” pay
              off...
              <br />
              <br />
              You're aiming at the wrong target.
              <br />
              <br />
              Free resources?
              <br />
              They’re often outdated or missing key insight.
              <br />
              Worse, they give you a false sense of progress — but no feedback
              on whether you’re actually scoring higher.
              <br />
              <br />
              Trying to teach yourself?
              <br />
              That only works if you know the scoring algorithm better than the
              system itself.
              <br />
              <br />
              But you don’t need to hack together a strategy from conflicting
              advice.
              <br />
              And you definitely don’t need to settle for another round of
              practice without results.
              <br />
              <br />
              There’s a better way. One rooted in understanding the actual
              mechanics behind the exam
              <br />
              — not guessing them.
              <br />
              This isn’t about English.
              <br />
              It’s about outsmarting the exam.
              <br />
              On its terms.
              <br />
            </p>
            <h3 className="sub-title">
              The Secret Isn't Better English —It's Smarter Prep.
            </h3>
            <p>
              <br />
              Our AI-powered platform delivers real-time feedback, accurate
              scoring, and updated strategies—so your next attempt isn’t just
              hopeful, it’s unstoppable.
              <br />
              <br />
              You see, most people think these exams are just a high-level
              English test.
              <br />
              They’re not.
              <br />
              <br />
              They’re engineered systems—with technical scoring schemes, hidden
              weightings, and strict formats that trip up even fluent speakers.
              <br />
              <br />
              So even when you “speak well,” you fail again.
              <br />
              Because you’re not speaking to the algorithm.
              <br />
              <br />
              That’s why downloading templates or repeating free practice tests
              isn't enough.
              <br />
              <br />
              They feed you outdated questions with no feedback, no context, and
              no insight into where you're bleeding points.
              <br />
              <br />
              We've spent over seven years cracking the systems behind these
              exams.
              <br />
              Our method doesn’t just prepare you—it aligns your entire
              performance with what the test actually rewards.
              <br />
              <br />
              You'll learn when to shift tone, how to hit scoring criteria in
              specific questions, and which “small” errors silently destroy your
              score.
              <br />
              <br />
              And unlike generic prep platforms, everything we give you is
              aligned with the latest exam algorithms—plus real-time coaching to
              apply it correctly.
              <br />
              It works for international students.
              <br />
              <br />
              Working professionals.
              <br />
              <br />
              And permanent residency seekers.
              <br />
              <br />
              Especially those frustrated by multiple fails and confusing
              advice.
              <br />
              If you've tried “everything” and still can’t pass—this is the
              piece you were missing.
            </p>
            <h2 className="title">
              <br />
              Because LA's Method <br /> Has FIVE (5) CRITICAL <br /> STAGES.
            </h2>
            <p>
              <br />
              These five stages flip the script on what most students believe
              about passing PTE, NAATI CCL, or IELTS.
              <br />
              <br />
              The truth? This isn’t a language test.
              <br />
              <br />
              It’s a technical game—and those who win know how the system works.
              <br />
              <br />
              Let me break down each stage for you...
              <br />
              <br />
            </p>
            <div className="d-none d-md-block">
              <div className="sale-stage-card card1">
                <div className="stage-color-box">
                  Stage
                  <span>1</span>
                </div>
                <div className="stage-content-card">
                  <h2>BREAK THE BELIEF</h2>
                  <p>
                    This is where it all starts—by unlearning what’s been holding
                    you back.
                    <br />
                    <br />
                    If you’ve failed once (or three times), it’s likely not your
                    English.
                    <br />
                    <br />
                    It’s the outdated strategy you've been taught.
                    <br />
                    <br />
                    In Stage 1, you’ll uncover why high-level speakers still get
                    punished by the exam and what really drives the scoring.
                    <br />
                    <br />
                    You’ll stop wasting time on general English and start
                    targeting the algorithm itself.
                  </p>
                </div>
              </div>
              <div className="sale-stage-card card2">
                <div className="stage-color-box">
                  Stage
                  <span>2</span>
                </div>
                <div className="stage-content-card">
                  <h2>DECODE THE EXAM STRUCTURE</h2>
                  <p>
                    Now that you see the exam for what it is—a technical
                    machine—you’ll start to learn how it really thinks.
                    <br />
                    <br />
                    Every part of these tests is engineered.
                    <br />
                    <br />
                    Each section has hidden weightings, priority triggers, and
                    behavioral cues.
                    <br />
                    <br />
                    In Stage 2, we’ll show you exactly where the system listens...
                    and where it doesn’t.
                    <br />
                    <br />
                    You’ll use that insight to focus on what counts —for real
                    results.
                  </p>
                </div>
              </div>
              <div className="sale-stage-card card3">
                <div className="stage-color-box">
                  Stage
                  <span>3</span>
                </div>
                <div className="stage-content-card">
                  <h2>TEMPLATE & TECHNIQUE MASTERY</h2>
                  <p>
                    This is where you separate from the pack.
                    <br />
                    <br />
                    Templates aren’t cheating. They’re a necessity.
                    <br />
                    <br />
                    In Stage 3, you’ll get high-precision frameworks that target the system’s known biases—response timing, sentence structuring, pronunciation hacks, pattern loops.
                    <br />
                    <br />
                    You’ll speak less, say more, and leave nothing to chance.
                  </p>
                </div>
              </div>
              <div className="sale-stage-card card4">
                <div className="stage-color-box">
                  Stage
                  <span>4</span>
                </div>
                <div className="stage-content-card">
                  <h2>PRACTICE THE ALGORITHM</h2>
                  <p>
                  Once you’ve got the right tools, it’s time to run simulations.
                    <br />
                    <br />
                    We don’t “practice English.”
                    <br />
                    <br />
                    We pressure-test performance under real algorithmic rules.
                    <br />
                    <br />
                    In Stage 4, you’ll go through guided drills with scoring feedback modeled on the exam engine itself.
                    <br />
                    <br />
                    You’ll stop guessing and start getting results before the next test day.
                  </p>
                </div>
              </div>
              <div className="sale-stage-card card5">
                <div className="stage-color-box">
                  Stage
                  <span>5</span>
                </div>
                <div className="stage-content-card">
                  <h2>RE-CODE YOUR CONFIDENCE</h2>
                  <p>
                  This stage isn’t just mental—it’s mechanical.
                  <br />
                    When you understand the system, and your scores rise in simulations, your mind follows.
                    <br />
                  <br />
                    In Stage 5, we help you lock in your timing, system habits, and scoring patterns so exam day feels like a formality.
                    <br />
                  <br />
                    You walk in with certainty—and walk out with your future.
                  </p>
                </div>
              </div>
            </div>

            <div className="d-block d-md-none slider-dot-arrow stage-slider-section">   
                <Slider {...StageSlider}>                             
                  <div className="sale-stage-card card1">
                    <div className="stage-color-box">
                      Stage
                      <span>1</span>
                    </div>
                    <div className="stage-content-card">
                      <h2>BREAK THE BELIEF</h2>
                      <p>
                        This is where it all starts—by unlearning what’s been holding
                        you back.
                        <br />
                        <br />
                        If you’ve failed once (or three times), it’s likely not your
                        English.
                        <br />
                        <br />
                        It’s the outdated strategy you've been taught.
                        <br />
                        <br />
                        In Stage 1, you’ll uncover why high-level speakers still get
                        punished by the exam and what really drives the scoring.
                        <br />
                        <br />
                        You’ll stop wasting time on general English and start
                        targeting the algorithm itself.
                      </p>
                    </div>
                  </div>
                  <div className="sale-stage-card card2">
                    <div className="stage-color-box">
                      Stage
                      <span>2</span>
                    </div>
                    <div className="stage-content-card">
                      <h2>DECODE THE EXAM STRUCTURE</h2>
                      <p>
                        Now that you see the exam for what it is—a technical
                        machine—you’ll start to learn how it really thinks.
                        <br />
                        <br />
                        Every part of these tests is engineered.
                        <br />
                        <br />
                        Each section has hidden weightings, priority triggers, and
                        behavioral cues.
                        <br />
                        <br />
                        In Stage 2, we’ll show you exactly where the system listens...
                        and where it doesn’t.
                        <br />
                        <br />
                        You’ll use that insight to focus on what counts —for real
                        results.
                      </p>
                    </div>
                  </div>
                  <div className="sale-stage-card card3">
                    <div className="stage-color-box">
                      Stage
                      <span>3</span>
                    </div>
                    <div className="stage-content-card">
                      <h2>TEMPLATE & TECHNIQUE MASTERY</h2>
                      <p>
                        This is where you separate from the pack.
                        <br />
                        <br />
                        Templates aren’t cheating. They’re a necessity.
                        <br />
                        <br />
                        In Stage 3, you’ll get high-precision frameworks that target the system’s known biases—response timing, sentence structuring, pronunciation hacks, pattern loops.
                        <br />
                        <br />
                        You’ll speak less, say more, and leave nothing to chance.
                      </p>
                    </div>
                  </div>
                  <div className="sale-stage-card card4">
                    <div className="stage-color-box">
                      Stage
                      <span>4</span>
                    </div>
                    <div className="stage-content-card">
                      <h2>PRACTICE THE ALGORITHM</h2>
                      <p>
                      Once you’ve got the right tools, it’s time to run simulations.
                        <br />
                        <br />
                        We don’t “practice English.”
                        <br />
                        <br />
                        We pressure-test performance under real algorithmic rules.
                        <br />
                        <br />
                        In Stage 4, you’ll go through guided drills with scoring feedback modeled on the exam engine itself.
                        <br />
                        <br />
                        You’ll stop guessing and start getting results before the next test day.
                      </p>
                    </div>
                  </div>
                  <div className="sale-stage-card card5">
                    <div className="stage-color-box">
                      Stage
                      <span>5</span>
                    </div>
                    <div className="stage-content-card">
                      <h2>RE-CODE YOUR CONFIDENCE</h2>
                      <p>
                      This stage isn’t just mental—it’s mechanical.
                      <br />
                        When you understand the system, and your scores rise in simulations, your mind follows.
                        <br />
                      <br />
                        In Stage 5, we help you lock in your timing, system habits, and scoring patterns so exam day feels like a formality.
                        <br />
                      <br />
                        You walk in with certainty—and walk out with your future.
                      </p>
                    </div>
                  </div>
              </Slider>
            </div>








            <p className="border-card border-gray-card">
              Each of these 5 stages replaces noise with clarity.
              <br />
              <br />
              You don’t need better English.
              <br />
              <br />
              You need the system cracked open.
              And we do just that.
            </p>
            <h3 className="sub-title">
              <br />
              "But I've already studied so <br /> much on my own..."
              <br />
              <br />
            </h3>
            <p>
              That’s exactly why this will work for you.
              <br />
              You’ve done the hard part — learning English.
              <br />
              <br />
              Now it's time to stop guessing and start decoding the system.
              <br />
              <br />
              See, these exams don’t just reward good English — they reward precision.
              <br />
              <br />
              That means knowing how the algorithm scores, how templates trigger points, and why timing matters even more than vocabulary.
            </p>
            <h3 className="sub-title">
              <br />
              "But I failed... more than once."
              <br />
              <br />
            </h3>
            <p>
              Even better.
              <br />
              <br />
              That means you’ve seen the traps firsthand.
              Most people waste time blaming their grammar.
              <br />
              <br />
              You now know — it’s not that.
              <br />
              <br />
              What’s missing is the blueprint designed for scoring, not speaking.
              And once you follow it, you'll stop crossing your fingers and start collecting points predictably.
            </p>
            <h3 className="sub-title">
              <br />
              "But I’ve been using free videos, forums, and mock tests..."
              <br />
              <br />
            </h3>
            <p>
              That’s where it gets risky.
              <br />
              <br />
              Free prep gives you guesses — not predictions.
              Tricks — not templates.
              <br />
              <br />
              Worse, you never get real feedback on where you're bleeding marks.
              We reverse that.
              <br />
              <br />
              You’ll use the exact prediction files tied to current scoring behavior, plus expert feedback that shows what the AI sees — not just what a tutor thinks.
            </p>
            <h3 className="sub-title">
              <br />
              "But I speak fluent English <br /> already..."
              <br />
              <br />
            </h3>
            <p>
              Exactly.
              <br />
              That’s what makes this so frustrating, right?
              <br />
              <br />
              You speak well… and still fail.
              <br />
              Because you're taking an exam that’s built like a machine — not a conversation.
              <br />
              <br />              
              When you treat it like a test of skill instead of a system to exploit, you lose.
              <br />
              But once you crack the code, you’ll start playing the exam the way it was built to be played.
            </p>
            <h3 className="sub-title">
              <br />
              "But I’m not sure what to focus on anymore..."
              <br />
              <br />
            </h3>
            <p>
              That’s actually the best place to begin.
              <br />
              <br />
              Because now, you’re ready to stop spinning and start aligning.
              <br />
              <br />
              Everything we teach is sharpened to one outcome: converting your raw English into the exact format the scoring system rewards.
              <br />
              <br />
              That means no fluff.
              <br />
              No random practice.
              <br />
              Just direct moves that push your score — fast.
              <br />
              <br />
            </p>
            <img
              className="img-fluid sale-img"
              src="/images/web-new-images/sales-page-img/img-02.png"
              alt="Image"
            />           
            <h2 className="title my-4">
              <br />
              Let’s quickly recap <br /> what we now know
            </h2>
            <p className="border-card border-gray-card">
              The real reason strong English speakers are still failing the PTE, NAATI CCL, and IELTS exams...has nothing to do with their intelligence or fluency.
            </p>
            <p className="border-card border-carrotorange-card">
               The biggest trap to avoid is treating these tests like regular language assessments. They aren't. They're algorithm-driven systems—and operating without a system of your own is what’s quietly sabotaging your scores.
            </p>
            <p className="border-card border-azure-card">
             The answer lies in breaking the exam code—with precision templates, expert scoring logic, and strategic feedback that works with the exam’s design, not against it.
            </p>
            <p className="border-card border-mediumpurple-card">
              These are the tools top scorers are using—tools you’re about to gain full access to through the most advanced AI-driven platform created for score-focused success.          
            </p>
            <div>
              <br />
              <br />
              <img
                className="img-fluid sale-img"
                src="/images/web-new-images/sales-page-img/img-03.png"
                alt="Image"
              />           
            </div>
            <h2 className="title">  
              <br />
              Introducing LA <br /> Language Academy
            </h2>
            <h3 className="sub-title my-4">
              The world’s most precise, expert-backed training system for scoring high in PTE, NAATI CCL, and IELTS.
            </h3>           
            <p>You’ll use a unique blend of live coaching, real-time AI feedback, prediction files, and proven methods that help you train like someone inside the scoring system itself.</p>
            <h3 className="sub-title my-4">I didn’t invent this insight <br /> —I uncovered it the hard way</h3>
            <p>
              This system wasn’t born overnight.
            <br />
            <br />
            After 12 perfect 90s in the PTE exam, I started reverse-engineering what others missed...not just how to speak English well, but how to respond the way the system rewards.
            <br />
            <br />
            Every strategy in LA Language Academy is battle-tested—not just by me, but by thousands of smart, capable students who kept failing...until they stopped guessing and started training with rules written for the exam, not the classroom.
            <br />
            <br />
            That’s the difference between trying to speak English and learning how to win marks.
            <br />
            <br />
            What you’ll get is a product of obsessively studying the structure, recreating the scoring model with AI...and stripping away everything that wastes your time.      
            </p>


             <h3 className="sub-title my-4">Trying to do this alone leads to stalled scores, again and again</h3>
            <p>
              You might think, “I can just gather some free tips and self-practice.”
              I’ve seen it.
              <br />
              <br />
              People bounce between YouTube videos, download scattered templates, and hope that guesswork delivers results. But it doesn’t.
              <br />
              <br />
              These exams aren’t built to reward effort.
              <br />
              They reward accuracy—on their terms.
              <br />
              They’re not judging your effort.
              <br />
              <br />
              That means you need templates that respond to algorithm triggers.
              <br />
              You need feedback that mimics the scoring engine.
              <br />
              <br />
              And you need real-time performance data for each section—data no YouTube video or free blog can give you.
              <br />
              <br />
              When smart students keep failing, it’s never because they didn’t try hard enough.
              <br />
              <br />
              It’s because they never trained for the system...only the language.   
              <br /> 
              <br /> 
            </p>
            <h3 className="sub-title my-4 text-uppercase">A quick heads up: This method won’t work for everyone</h3>
            <p>
              There are a few people I can’t help—and I'd rather be upfront than waste your time.
              LA Language Academy probably isn’t for you if:
              <br />
              <br />
            </p>
             <p className="border-card border-gray-card">
              You’re looking for a casual practice tool without any commitment. This is made for serious test-takers—those whose future depends on getting it right.
            </p>
            <p className="border-card border-carrotorange-card">
              You’re allergic to feedback. If you won’t use corrections or avoid strict scoring, this system won’t serve you.
            </p>
            <p className="border-card border-azure-card">
             You still believe raw fluency is enough. If you're not ready to accept that strategy and scoring knowledge matter more than “good English,” this will feel too technical for you.
            </p>
            <p className="border-card border-mediumpurple-card">
              Or, you plan on watching a few classes, never practicing, and hoping for luck on exam day. That’s not how mastery happens.        
            </p>            
            <p>
              We want students who care about results—and are willing to use the edge they’ve been missing.
            </p>
            <h3 className="sub-title my-4">The best systems are always the simplest—once someone shows you how</h3>
            <p>Everything we teach at LA Language Academy has been refined to its core.
              <br />
              <br />
              You'll speak less and score more.
              <br />
              You'll practice less and improve faster.
              <br />
              <br />
              You’ll waste less time guessing—and instead train like someone scoring from the inside.
              <br />
              <br />
              What used to be frustrating and confusing is now mapped, simplified, and delivered inside a training platform that adjusts to your performance in real time.
              <br />
              <br />
              Smart systems solve complex problems.
              <br />
              And now, that system is yours.
              </p>
              <div className="sales-user-info">
                  <div className="user-info">
                    <div className="user-img">
                      <img src="/images/web-new-images/crack-user.png" alt="Image" />
                    </div>
                    <div>
                      <h2 className="user-name">Nancy S.</h2>
                      <h3 className="user-location">Sydney, Australia</h3>
                    </div>
                  </div>   
                   <div className="user-description">
                    Nancy S. told us, “I had taken the PTE exam twice before and always missed by a few marks. After joining LA, I finally understood what I was doing wrong. The feedback was so detailed, and the templates just worked! I got 90 on my next attempt.”
                  </div>                
              </div>
              <p>
                Imagine sitting down for your third PTE attempt—nervous, but prepared.
                <br />
                <br />
                Then walking out knowing you nailed it.
                <br />
                That’s what happened for Nancy.
                <br />
                A perfect 90 score.
                <br />
                <br />
                Clear path to PR points.
                <br />
                No more guesswork, just confidence.
                <br />
                <br />
                Ravneet T. shared, “I tried multiple apps and free resources, but nothing came close to the accuracy of LA’s platform. Their scored mock test was exactly like the real exam. I followed their strategies and got my PR points sorted!”
                <br />
                <br />
                She had tried everything—YouTube videos, free apps, endless practice tests.
                <br />
                <br />
                But still no results.
                <br />
                Then she found LA.
                <br />
                The mock exams were so spot-on, it felt like déjà vu in the test center.
                PR points? Locked in.
                <br />
                <br />
                Sujal T. told us, “No one else offers the kind of 1-on-1 feedback and support LA does. I cracked NAATI CCL in one go after struggling for months with no clear direction.”
                <br />
                <br />
                He spent months spinning his wheels.
                <br />
                <br />
                Confused.
                <br />
                Frustrated.
                <br />
                Then LA stepped in with real, personal feedback—and boom.
                <br />
                <br />
                NAATI CCL cleared in a single shot.
                <br />
                And these aren’t the only wins we’ve seen.
                <br />
              </p>
              <p className="border-card border-gray-card">
                Stories like this land in our inbox every week from test-takers around the world finally seeing results that move their dreams forward.
              </p>
              <h3 className="sub-title my-4">Why it’s just $29 to get started (and $349 only when you’re ready)</h3>
              <p>
                I wanted to make this the clearest path ever for students and professionals tired of hitting a wall with their PTE, NAATI CCL, or IELTS results—despite a solid grasp of English.
                <br />
                <br />
                That frustration? I know it well.
                <br />
                <br />
                Because the truth is, these exams don’t reward good English—they reward understanding the system.
                <br />
                <br />
                And once I saw how many brilliant, fluent test-takers were held back by scoring rules they didn’t even know existed, I knew I had to open the doors wider.
                <br />
                <br />
                That’s why I made it just $29 to step inside.
                <br />
                <br />
                At that price, you get access to everything you need to finally decode the exam: live coaching, breakdowns of the scoring logic, and platform access that shows you exactly where points are gained (and lost).
                <br />
                <br />
                Then when you're ready... and only when you're ready... you can level up to our full program for $349.
                <br />
                <br />
                That’s how serious I am about removing the guesswork—for good.
                Because this isn’t just “language practice.”
                <br />
                <br />
                It’s high-precision training designed to crack the system behind the test—so you score right where you need to and finally move forward with your career, your studies, or your residency plans.
                <br />
                <br />
                For less than a few tutoring hours elsewhere, you’ll get 7+ years of real results—and a team that’s helped over 50,000 students get the score they thought was out of reach.
                <br />
                <br />
                No fluff.
                <br />
                No dead ends.
                <br />
                Just what works.
              </p>
              <h3 className="sub-title py-4">Here’s why I don’t offer <br /> a money-back guarantee</h3>
              <p>
                Unlike most programs that promise refunds instead of results, I decided to do something different.
                <br />
                <br />
                I built a method that doesn’t need to hide behind guarantees—because the track record is proven.
                <br />
                <br />
                Over 50,000 students have used this exact system to finally get the results they needed—after trying everything else.
                <br />
                <br />
                Instead of hoping it works, you’ll follow a process built on what the scoring systems actually prioritize.
                <br />
                <br />
                You’ll gain clarity.
                <br />
                You’ll gain control.
                <br />
                You’ll gain results.
                <br />
                That’s the confidence I stand on—not a return policy.
              </p>
              <h3 className="sub-title py-4">A quick heads up</h3>
              <p>
                This offer won’t stay at $29 forever.
                <br />
                <br />
                Once we hit capacity on our coaching slots or platform bandwidth, we’ll need to adjust.
                <br />
                <br />
                But until then, you can still jump in at the lowest entry ever—and get access to a system that changes the game.
              </p>
              <h3 className="sub-title py-4">Before You Go, I Owe You One Last Truth...</h3>
              <p>
                This won’t be easy to hear—but if you’ve read this far, you deserve full honesty.
                <br />
                <br />
                You can keep trying to “get better at English.”
                <br />
                Read more grammar books.
                <br />
                <br />
                Attempt another round of YouTube videos.
                 <br />
                Take five mock tests hoping one of them finally clicks.
                 <br />
                But that route? It’s the exact reason thousands of smart, fluent, hardworking students like you keep failing the PTE, NAATI CCL, or IELTS again…
                 <br />
                  <br />
                And again.
                 <br />
                It's not because you’re not good at English.
                 <br />
                It’s because these exams don’t reward fluent English—they reward system mastery.
                 <br />
                  <br />
                Scoring isn’t random.
                 <br />
                Every test has hidden patterns, algorithm-specific priorities, and a technical blueprint most test-takers never even learn exists.
                 <br />
                And every time you walk into the exam room without knowing that code, you may as well walk in blind.
                 <br />
                  <br />
                The cost? Each failure drags you further from your visa…PR…career…life.
                 <br />
                That’s what keeps people stuck—paying endless exam fees, explaining scores to employers and agents, and watching as others move ahead.
                Meanwhile, those who’ve trained with us at LA Language Academy—people with LESS natural English than you—are walking away with their score sheets in hand.
                 <br />
                  <br />
                That's because we don’t just teach you English.
                 <br />
                We train you inside the algorithm.
                 <br />
                We decode the scoring architecture.
                 <br />
                We translate the system into a step-by-step roadmap that has helped over 50,000 students beat the exam…
                 <br />
                 <br />
                Many on their very next attempt.
                 <br />
                 <br />
                And today, you get in for just AUD $29 (was AUD $349).
              </p>
              <h3 className="sub-title py-4">When you say YES today, you:</h3>
              <p className="border-card border-gray-card">Learn exactly how to structure answers the algorithm loves</p>
              <p className="border-card border-gray-card">Train under expert guidance who know what actually triggers scoring marks</p>
              <p className="border-card border-gray-card">Receive real-time AI feedback on the same platform used for actual exams</p>
              <p className="border-card border-gray-card">Finally, stop guessing and start targeting only what works</p>
              <p className="border-card border-gray-card">Fast-track your success—so your visa or PR process doesn’t get delayed again</p>   
              <p>
                No tricks.
                <br />
                No fluff.
                <br />
                <br />
                Just the technical truth—and the tools to conquer it.
                <br />
                <br />
              </p>       
              <h2 className="primary-heading fw-700">Start Now <br />
              For Just <span className="free-mock-text">AUD $29</span></h2>
              <p>
                Click below to lock in your discounted rate and gain full access to the proven framework trusted by over 50,000 achievers.
                <br />
                Don’t miss this.
                <br />
                Because the longer you keep “practicing harder,” the more time you lose, the more money you waste, and the more chances slip through your fingers.
                <br />
                Your roadmap is right here.
                <br />
                To your breakthrough,
                <br />
                <br />
              </p>
               <div className="sales-user-info new-info-card">
                  <div className="user-info">
                    <div className="user-img">
                      <img src="/images/web-new-images/crack-user.png" alt="Image" />
                    </div>
                    <div>
                      <h2 className="user-name">Nancy S.</h2>
                      <h3 className="user-location">Sydney, Australia</h3>
                    </div>
                  </div>              
              </div>
              <p className="border-card border-gray-card">
                P.S. – Most students never realize why they keep failing until it’s too late.
                You don’t have to be one of them.
                <br />
                <br />
                Train smarter.
                <br />
                <br />
                Pass faster.
                <br />
                <br />
                P.P.S. – No money-back guarantee—because our results speak for themselves.
                <br />
                <br />
                More than 50,000 success stories prove the system works.
                All you have to do is begin.
              </p>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}
